angular
    .module('AutoPrequal')
    .controller('applicantAddressCtrl', applicantAddressCtrl);

applicantAddressCtrl.$inject = ['$scope', '$rootScope', 'ScrollFactory', 'DataFactory', '$timeout', '$filter'];

function applicantAddressCtrl($scope, $rootScope, ScrollFactory, DataFactory, $timeout, $filter) {

	$rootScope.progressCurrent = 3;
	$rootScope.progressMobCurrent = 3;

	$scope.content = DataFactory.appData.content;
	$scope.localContent = DataFactory.appData.content.address;
	$scope.POBox = false;

	$scope.data = DataFactory.appData.applicant;

	if ($scope.data.POBox === "Yes") {
		$scope.POBox = true;
	}

	$scope.$watch('addressModalForm', function (form) {
		if (form && DataFactory.appData.applicant.apStreetName) addressModalDone();
	});

	$scope.addressType = "residential";
	$scope.showAddressModal = false;
	$scope.addressModalFocus = false;
	$scope.submittedModal = false;
	$scope.addressModalDone = addressModalDone;
	$scope.checkPOBox = checkPOBox;
	$scope.checkProvince = checkProvince;
	$scope.openAddressModal = openAddressModal;

	$timeout(function () {
		jQuery("#btnAddressManual .offscreen").remove();
	}, 1000);
	
    if ($(window).width() <= 768) {
        $scope.addressPlaceholder = "";
    } else {
        $scope.addressPlaceholder = $scope.localContent.address_placeholder;
    }
    $(window).on('resize', function () {
        if ($(window).width() <= 768) {
            $scope.addressPlaceholder = "";
            $scope.$apply();
        } else {
            $scope.addressPlaceholder = $scope.localContent.address_placeholder;
            $scope.$apply();
        }
    })

    $scope.provinceArray = Object.keys($scope.content.province).map(function (key) {
        return { key: key, value: $scope.content.province[key] };
    })

	function openAddressModal() {
		$scope.showAddressModal = true;
		$scope.addressModalFocus = true;
	}

    function addressModalDone(refocus) {
        $scope.submittedModal = true;
        if ($scope.addressModalForm.$valid) {
            $scope.showAddressModal = false;
            if ($scope.data.apStreetNum) {
                $scope.apAddress = $scope.data.apStreetNum + " " +
                    $scope.data.apStreetName + ", " +
                    $scope.data.apCity + ", " +
                    $scope.data.apProvince + ", Canada";
                $scope.data.apAddress = $scope.apAddress;
            } else {
                $scope.apAddress = $scope.data.apStreetName + ", " + $scope.data.apCity + ", " + $scope.data.apProvince + ", Canada";
                $scope.data.apAddress = $scope.apAddress;
            }
        } else if (refocus) {
            $timeout(function () {
                var list = $('form[name="addressModalForm"] .error:visible');
                list[0].focus();
            })
        }
    }

    function checkPOBox(value) {
        $scope.POBox = $filter("checkPOBox")(value);
        if ($scope.POBox) {
            $scope.data.apStreetName = value;
        }
    }

    function checkProvince() {
        var value = $scope.data.apPostalCode;
        var province = $scope.addressModalForm.apProvince.$viewValue;
        var field = $scope.addressModalForm.apPostalCode;

        var isValid = $filter("checkPostalCode")(value, province);

        isValid ? field.$setValidity('', true) : field.$setValidity('', false);
    }

    $rootScope.applicantAddressNextStep = function () {
        if ($scope.Address.$valid && $scope.addressModalForm.$valid) {

            if ($scope.data.apStreetNum) {
                $scope.apAddress = $scope.data.apStreetNum + " " +
                    $scope.data.apStreetName + ", " +
                    $scope.data.apCity + ", " +
                    $scope.data.apProvince + ", Canada";
                $scope.data.apAddress = $scope.apAddress;
            }
            else {
                $scope.apAddress = $scope.data.apStreetName + ", " + $scope.data.apCity + ", " + $scope.data.apProvince + ", Canada";
                $scope.data.apAddress = $scope.apAddress;
            }

            $scope.data.apPostalCode = $scope.data.apPostalCode.toUpperCase().replace(/ /g, "");

            $scope.data.POBox = $scope.POBox ? "Yes" : "No";

            DataFactory.setData($scope.data);

            DataFactory.appData.applicant.appState.applicantAddress = true;

            ScrollFactory.showStep("birthdayMonth");
			ScrollFactory.goToStep("birthdayMonth");
            return true;
        }
        else {
            if (!$scope.addressModalForm.$valid)
                $scope.showAddressModal = true;
				$scope.submittedModal = true;
				angular.forEach($scope.Address.$error, function (field) {
					angular.forEach(field, function (errorField, index) {
						errorField.$setTouched();
						$rootScope.errorNumber = index + 1;
					})
				});
				angular.forEach($scope.addressModalForm.$error, function (field) {
					angular.forEach(field, function (errorField, index) {
						errorField.$setTouched();
						$rootScope.errorNumber = index + 1;
					})
				});
        }
    }

    $scope.prevStep = function () {
        ScrollFactory.showStep("applicantContact");
		ScrollFactory.goToStep("applicantContact");
    }
}
